import axios from '../_helpers/axios'

const route = 'Types'.toLowerCase()
const createType = async (createBody) => axios.post(`v1/${route}`, createBody)
const getTypes = async (options) =>
  axios.get(
    `v1/${route}?${Object.keys(options)
      .map((key) => `${options[key] ? `&${key}=${options[key]}` : ''}`)
      .join('')}`
  )
const getType = async (id) => axios.get(`v1/${route}/${id}`)
const updateType = async (id, updateBody) =>
  axios.patch(`v1/${route}/${id}`, updateBody)
const deleteType = async (id) => axios.delete(`v1/${route}/${id}`)
export default {
  createType,
  getTypes,
  getType,
  updateType,
  deleteType,
}
